/**
 * imageSlots.ts
 * Source unique des conventions d'affichage d'images du site.
 *
 * Pourquoi : avant, chaque page choisissait son propre ratio / sa propre
 * hauteur fixe (aspect-[4/3], aspect-square, h-44 md:h-auto, w-14 h-14, …),
 * ce qui donnait des tailles incohérentes et des sujets coupés. Ici on fige
 * un petit jeu de « slots » réutilisés partout via <SmartImage>.
 *
 * IMPORTANT (Tailwind v4) : ces valeurs doivent rester des classes LITTÉRALES
 * complètes — ne pas les construire par concaténation runtime, sinon Tailwind
 * ne les voit pas au build et ne génère pas le CSS.
 */

/** Ratios / tailles standard par rôle d'image. */
export const IMAGE_SLOT = {
  /** Vignette de carte publique (cocktails, bouffe, dégustation, top-rated). */
  publicCard: 'aspect-[4/3]',
  /** Grande photo de page détail (modal public + détail admin). */
  detailHero: 'aspect-[4/3]',
  /** Miniature de ligne de liste admin (s'aligne sur les squelettes h-12 w-12). */
  listThumb: 'size-12',
  /** Photo portrait éditoriale (Home Apercus/Visite, À-propos équipe, Cave). */
  portraitFeature: 'aspect-[4/5]',
  /** Conteneur produit / logo (image en object-contain, voir SmartImage fit). */
  productCard: 'aspect-[4/3]',
} as const;

/**
 * Points de cadrage (CSS object-position) par défaut.
 * Pertinent uniquement pour object-cover ; ignoré pour object-contain.
 */
export const FOCAL = {
  /** Centre strict. */
  default: 'center',
  /** Biais vers le haut → garde têtes / garnitures / haut des plats dans le cadre. */
  people: 'center 30%',
  /** Produits / logos : centré (l'image est entièrement visible en contain). */
  product: 'center',
} as const;

export type ImageSlot = keyof typeof IMAGE_SLOT;
export type Focal = keyof typeof FOCAL;
